(ns teamoesterreich.user-mode.prevent.prevent-overview
  (:require
    [clojure.string]
    [reagent-material-ui.components :as mui]
    [reagent-material-ui.icons.add :refer [add]]
    [reagent-material-ui.icons.keyboard-arrow-left :refer [keyboard-arrow-left]]
    [reagent.core :as r]

    [teamoesterreich.firebase.provider :as provider]
    [teamoesterreich.store :as store]
    [teamoesterreich.user-mode.actions :as a]
    [teamoesterreich.user-mode.prevent.prevent-location :as prevent-location]
    [teamoesterreich.user-mode.prevent.prevent-personal :as prevent-personal]
    [teamoesterreich.util.log :as log]

    ))


(defn get-personal-questionnaires []
  [mui/grid
   {:container false
    :item      true
    :xs        12
    }
   (prevent-personal/get-card)
   ])



(defn get-location-questionnaires []
  [mui/grid
   {:container false
    :item      true
    :xs        12
    }
   "Questionnaires"
   ])




(defn get-locations []
  (let [!location-list (r/cursor store/app-state [:locations])
        fav-location (provider/get-fav-locationId)]
    (log/out "Location-card " (clj->js @!location-list))

    (if (empty? @!location-list)
      (do
        [mui/grid
         {:container false
          :item      true
          :lg        10
          :xs        12
          }
         [mui/typography {:variant "h5"} "Bitte erstelle hier Orte für die du dich vorbereiten möchtest."]
         ])
      (doall (for [[locationId location] (sort-by (fn [[id obj]] (if (= fav-location id) 0 1)) @!location-list)]
               ^{:key (str "location-" locationId)} [mui/grid
                                                     {:container false
                                                      :item      true
                                                      :lg        12
                                                      :xs        12

                                                      }
                                                     (prevent-location/card locationId (= fav-location locationId))

                                                     ])))))



(defn get-it []
  (fn []

    [mui/grid
     {:container  true
      :direction  "row"
      :justify    "center"
      :alignItems "stretch"
      :spacing    1
      }

     [mui/grid
      {:container false
       :item      true
       :xs        12
       }
      ""]
     [mui/grid
      {:container false
       :item      true
       :lg        7
       :xs        11
       }

      [mui/grid
       {:container  true
        :direction  "row"
        :justify    "center"
        :alignItems "center"
        :spacing    3
        }
       (get-personal-questionnaires)

       [mui/grid
        {:container false
         :item      true
         :lg        12
         :xs        12

         }
        [:br]
        [mui/typography {:variant "h5"} "Meine Standorte"]

        (get-locations)

        ]



       [mui/grid
        {:container false
         :item      true
         :xs        6

         }

        [mui/button
         {:variant   "contained"
          :color     "default"
          :class     "bottom-button"
          :onClick   #(a/set-page :landing)
          :startIcon (r/as-element [keyboard-arrow-left])
          }
         "Zurück"]]

       [mui/grid
        {:container false
         :item      true
         :xs        6

         }
        [mui/button
         {:variant   "contained"
          :color     "primary"
          :onClick   #(a/set-page :prevent-locationCreate)
          :startIcon (r/as-element [add])
          }
         "Neuer Standort"]]
       ]]]
    ))